/**
 * Function to convert a first letter of the word to uppercase
 * @param value
 * @returns
 */
function CapitalizeFirstLetter(value: string) {
  if (!value) {
    return value;
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/**
 * Function to update file name
 * @param fileName
 * @returns
 */
function SanitizeFileName(fileName: string) {
  return fileName.replace(/[^a-zA-Z0-9]/g, '_');
}

// Change default export when adding more functions
export { CapitalizeFirstLetter, SanitizeFileName };
